module.exports = __webpack_public_path__ + "img/6.50f9f4ab.png";